import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "fixed bottom-0 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paginator_on = _resolveComponent("paginator-on")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_paginator_on, {
        rows: _ctx.rowsPerPage,
        totalRecords: _ctx.totalRecords,
        first: (_ctx.currentPage - 1) * _ctx.rowsPerPage,
        pageCount: _ctx.maxPages,
        template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
        currentPageReportTemplate: "{first} até {last} de {totalRecords}",
        onPage: _ctx.onPageChange,
        pt: {
          root: {
            class: [
              'bg-gray-800', 'text-sm md:text-base', 'rounded-none',
              'text-slate-300', 'py-1 lg:py-0', 'sd: p-1'
            ]
          },
          current: ['text-slate-300'],
          firstpagebutton: ['hover:bg-gray-700 active:scale-90'],
          previouspagebutton: ['hover:bg-gray-700 active:scale-90'],
          nextpagebutton: ['hover:bg-gray-700 active:scale-90'],
          lastpagebutton: ['hover:bg-gray-700 active:scale-90']
        }
      }, null, 8, ["rows", "totalRecords", "first", "pageCount", "onPage"])
    ])
  ]))
}